import { Text, TextProps } from '@chakra-ui/react'

import { useChartColors } from './useChartColors'

export interface ChartSubtitleProps extends TextProps {
  children?: React.ReactNode
}

export const ChartSubtitle = ({ children, ...props }: ChartSubtitleProps) => {
  const chartColors = useChartColors()

  return (
    <Text
      fontWeight={500}
      fontSize="12px"
      color={chartColors.subtitleColor}
      {...props}
    >
      {children}
    </Text>
  )
}
